import { environment } from '../environments/environment';

export class Config {
  static commonIteration: string = '86.1'; // <-- Current sprint release iteration of sprint
  static appVersion: string = `3.${Config.commonIteration}`;
  static devVersion: string = `14.0.${Config.commonIteration}`;

  static defaultPage = '#/';
  static disableStationAssignment = false;
  static momentDateFormatUs = 'YYYY-MM-DD';
  static hereMapsApiKey = 'X8jW4-f8PQ0L5hANQom39_pmwRJlcVYS55uLGkaEDGE';
  static fusionchartsLicense =
    '5bD2nuyE1C3C11D5D4F3D2D1F2B2H3C10D7D-13iaD3E2vpB-21d1qE2B2dI-8mB1B11B1C4F4B3C2G3A15A17A12A4C1C6B5G4xgaA9C5A5qE3E1A2dgrA4B8E2C-11xoH1F2C2lttE6E1G4I2G3A3C7D2B5D6D3kcH-7B5D7HB2sudC1I2A3B-16hE1CA2B4dfwB7D1B5C2H2C1G1D3B2B1A6D1B4C2o==';

  static assetCdnRoot = environment.cdnRoot;
  static languageAssetCdnRoot = environment.languageAssetCdnRoot;
  static vrmFormsLanguageAssetCdnRoot = environment.vrmFormsLanguageAssetCdnRoot;
  static oneTrustCookieDataValue = environment.oneTrustCookieDataValue;
  static apiRoot = environment.api;
}
